import React, { useEffect, useState } from 'react';
import PropTypes, { func } from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Button, useTheme } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import theme from '../../../../theme';
import { Values } from '../../../../values/Values';
import Alert from '@material-ui/lab/Alert';


const useStyles = makeStyles(theme => ({
  root: {
    margin: theme.spacing(2)
  },
  row: {
    height: '35px',
    display: 'flex',
    alignItems: 'center',
  },
  spacer: {
    flexGrow: 1
  },
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  searchInput: {
    marginRight: theme.spacing(1)
  },
  buttonDelete: {
    backgroundColor: '#DC004E',

  },
  buttons: {
    marginLeft: 15,
  }
}));

const VisitaFiliadoRegisterDetalhadoToolbar = props => {
  const {
    className,
    history,
    activeStep,
    steps,
    stepNext,
    stepBack,
    saveVisita,
    visitaFiliado,
    deleteVisita,
    ...rest } = props;
  const [openDialogCancel, setOpenDialogCancel] = React.useState(false);
  const [espacamentoMinimo, setEspacamentoMinimo] = useState(2);
  const theme = useTheme();

  const classes = useStyles();

  useEffect(() => {
    calcularEspacamento()
  }, [visitaFiliado, activeStep]);

  function calcularEspacamento() {
    let espacamento = 2;
    if(! (activeStep !== steps.length - 1)){
      espacamento += 4;
    }
    if(! (activeStep > 0)){
      espacamento += 2;
    }
    setEspacamentoMinimo(espacamento);
  }

  const cancelarInsercao = () => {
    history.goBack();
  };

  function abrirDialogCancel () {
    setOpenDialogCancel(!openDialogCancel);
  }

  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        md={2}
        xs={12}
      >
        {
          visitaFiliado.idVisitaFiliado &&
          <Button
            variant="contained"
            fullWidth
            color={'primary'}
            className={classes.buttonDelete}
            startIcon={<DeleteIcon/>}
            onClick={e => deleteVisita()}
          >
            DELETAR
          </Button>
        }
      </Grid>

      <Hidden xsDown>
        <Grid
          item
          md={espacamentoMinimo}
          sm={espacamentoMinimo}
        />
      </Hidden>
      {activeStep != steps.length - 1 &&
      <Grid
        item
        md={2}
        xs={12}
      >

        <Button
          variant="contained"
          fullWidth
          onClick={saveVisita}
          margin='dense'
          style={{
            backgroundColor: theme.palette.info.main,
            color: theme.palette.info.contrastText
          }}
        >
          Salvar e sair
        </Button>
      </Grid>
      }
      <Grid
        item
        md={2}
        xs={12}
      >
        <Button
          fullWidth
          color="primary"
          variant="outlined"
          onClick={cancelarInsercao}
        >
          Cancelar
        </Button>
      </Grid>

      {activeStep > 0 &&
        <Grid
          item
          md={2}
          xs={12}
        >

          <Button
            color="primary"
            variant="outlined"
            fullWidth
            onClick={stepBack}
          >
            Voltar
          </Button>

        </Grid>
      }
      {activeStep != steps.length - 1 &&
        <Grid
          item
          md={2}
          xs={12}
        >
          <Button
            color="primary"
            variant="contained"
            onClick={stepNext}
            fullWidth
            margin='dense'
          >
            Próximo
          </Button>
        </Grid>
      }
      {
        visitaFiliado?.filiado?.idFiliacaoStatus === Values.FiliacaoStatusValues.inadimplente &&
        <Grid
          item
          md={12}
          xs={12}
        >
          <Alert severity="error">ATENÇÃO - Filiado inadimplente. Necessário atenção.</Alert>
        </Grid>
      }
    </Grid>
  );
};

VisitaFiliadoRegisterDetalhadoToolbar.propTypes = {
  className: PropTypes.string
};

export default VisitaFiliadoRegisterDetalhadoToolbar;
